import { onOpenDrawer, selectDrawerState , onSetShoppinCart, onSetDraweSelectCustomer, onSetDraweSelectSalesman} from "../redux/slices/drawerSlice"
import { useDispatch, useSelector } from "../redux/store"


export const useDrawerStore = () => {

    const dispatch = useDispatch()
    const { drawerOpen, shoppingCart, selectCustomer, openSelectSalesman } = useSelector(selectDrawerState)

    const openDrawer = (value: boolean) => {
        dispatch(onOpenDrawer(value))
    }

    const setShoppingCart = (value: boolean) => {
        dispatch(onSetShoppinCart(value))
    }

    const setDrawerSelectCustomer = (value:boolean) => {
        dispatch(onSetDraweSelectCustomer(value))
    }

    const setDrawerSelectSalesman = (value:boolean) => {
        dispatch(onSetDraweSelectSalesman(value))
    }
    
    return {
        //states
        shoppingCart,
        drawerOpen,
        selectCustomer,
        openSelectSalesman,
        //actions
        openDrawer,
        setShoppingCart,
        setDrawerSelectCustomer,
        setDrawerSelectSalesman,
    }
}